import { createSelector } from '@reduxjs/toolkit'

export const selectUserHasResponded = createSelector(
  ({ app }) => app,
  ({ userHasResponded }) => userHasResponded,
)
